import { render } from "./TheFooter.vue?vue&type=template&id=5b9775cf"
const script = {}

import exportComponent from "/home/siluniv/projects/mediasphere/bluedot-ai-home/origin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__